module.exports = __webpack_public_path__ + "static/img/nav_logo.8ca89750.png";